import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
import {
  FormInput,
  FormTemplate,
  FormSelect,
  // SlideCheckBox,
  // FormTextArea,
  FormattedNumberInput,
} from "../../../Components/Forms/InputTemplate";
import { FormProvider, useForm } from "react-hook-form";
import {
  ActionButtons,
  SupportButtons,
} from "../../../../global/components/Buttons/buttons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  // CreateProcQuotation,
  // GetSingleProcRequisitions,
  SendQuotationPaymentTerms,
  // UpdateProcQuotation,
  UpdateQuotationPaymentTerms,
} from "../../../../../utils/redux/Procurement/ProcurementSlice";
import Table from "../../../Components/Table/Table";
// import {
//   TableActions,
//   TableActionsDownload,
// } from "../../../Components/Misc/Actions";
// import FormUploadComponent from "../../../Components/Forms/FormUploadComponent";
import {
  FormatDateTime,
  // FormatWithEmptyDateTime,
  // GetSearchParams,
  // removeListData,
} from "../../../../../utils/functions/ResourceFunctions";
// import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
import { GetSingleVendor } from "../../../../../utils/redux/Vendor/VendorSlice";
// import { USER_CATEGORY } from "../../../../../utils/Enums";
import { toast } from "react-toastify";
import { getWitholdingTaxSetup } from "../../../../../utils/redux/Finance/PaymentSetup/PaymentSetupSlice";
// import { GetVendorType } from "../../../../../utils/redux/Global/GlobalSlice";
import { GetAssetClass } from "../../../../../utils/redux/AssetsSetUp/AssetSetUpSlice";
import {
  declinePaymentToFinance,
  SendPaymentToFinance,
} from "../../../../../utils/redux/Finance/PayrollSlice";
import { GetEmployeeBanks } from "../../../../../utils/redux/Employee/EmployeeSlice";
import {
  GetConsummableClassByClassId,
  GetConsummableRegister,
} from "../../../../../utils/redux/ConsummableSetUp/ConsummableSetUpSlice";

function AddPaymentTerms({
  id,
  requisition,
  setRefresh,
  refersh,
  paymentTerms,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const formMethods = useForm({
    defaultValues: {
      managementFee: "",
      gross: "",
      vat: "",
      grossPlusVat: "",
      withholdingTax: "",
      totalPayable: "",
      installmentType: 0,
      paymentSplit: 1, // Default to 1 payment if staggered selected
    },
    mode: "all",
  });

  const { handleSubmit, setValue, watch } = formMethods;
  const [isLoading, setIsLoading] = useState(false);

  const { isSubmitting } = useSelector((state) => state?.procurement);

  const vendorDetails = useSelector(
    (state) => state?.vendor?.vendors?.responseObject
  );

  const assetClassDetails = useSelector(
    (state) => state?.assetSetUp?.asset_class?.responseObject
  );

  const consummableDetails = useSelector(
    (state) => state?.consummableSetUp?.Consummable_register?.result
  );

  const consummableVatAndWitholdingTax = useSelector(
    (state) => state?.consummableSetUp?.consummableByClassId?.responseObject
  );

  console.log("consummableVatAndWitholdingTax", consummableVatAndWitholdingTax);

  const witholdingTaxSetupDetails = useSelector(
    (state) => state?.paymentSetup?.witholdingTaxSetup?.result
  );

  const [isApproved, setIsApproved] = useState(false);

  const banks = useSelector((state) => state?.employee?.banks?.responseObject);

  const vatDetail =
    requisition?.requisitionType === "Consumable"
      ? consummableVatAndWitholdingTax?.[0]?.vat || 0
      : assetClassDetails?.[0]?.vat || 0;
  const witholdingTaxSetupFee = witholdingTaxSetupDetails?.[0]?.fee || 0;
  const witholdingTaxSetupPercentage =
    witholdingTaxSetupDetails?.[0]?.percentage || 0;

  const managementFee = watch("managementFee");
  const installmentType = watch("InstalmentType");
  const paymentSplit = watch("paymentSplit");

  const generateRandomNumberString = (count) => {
    // Generate an array of random numbers
    const numbersArray = Array.from({ length: count }, () =>
      String(Math.floor(Math.random() * 10)).padStart(2, "0")
    );
    // Convert the array to a string
    return numbersArray.join("");
  };

  // Helper function to get ordinal form
  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  // console.log("test", requisition);

  useEffect(() => {
    if (
      requisition?.totalPrice !== undefined &&
      assetClassDetails &&
      witholdingTaxSetupDetails
    ) {
      const calculatedGross =
        Number(managementFee) + (requisition?.totalPrice || 0);

      const calculatedVat = managementFee
        ? Number(managementFee) * (vatDetail / 100)
        : requisition?.totalPrice * (vatDetail / 100);

      const calculatedTotalPrice = calculatedGross + calculatedVat;

      // const calculatedWithholdingTax = managementFee
      //   ? (witholdingTaxSetupPercentage / 100) * Number(managementFee)
      //   : (witholdingTaxSetupPercentage / 100) * requisition?.totalPrice;

      const calculatedWithholdingTax = managementFee
        ? ((requisition?.requisitionType === "Consumable"
            ? (consummableVatAndWitholdingTax?.[0]?.withHoldingTax || 0)
            : witholdingTaxSetupPercentage) /
            100) *
          Number(managementFee)
        : ((requisition?.requisitionType === "Consumable"
            ? (consummableVatAndWitholdingTax?.[0]?.withHoldingTax || 0)
            : witholdingTaxSetupPercentage) /
            100) *
          requisition?.totalPrice;

      // console.log("Calculated Withholding Tax:", calculatedWithholdingTax);

      const calculatedTotalPayable =
        calculatedTotalPrice - calculatedWithholdingTax;
console.log('calculated witholding tax',calculatedWithholdingTax)
      setValue("gross", calculatedGross);
      setValue("VAT", calculatedVat);
      setValue("grossPlusVat", calculatedTotalPrice);
      setValue("WithholdingTax", calculatedWithholdingTax);
      setValue("TotalPayable", calculatedTotalPayable);
    }
  }, [
    managementFee,
    requisition?.totalPrice,
    vatDetail,
    witholdingTaxSetupPercentage,
    setValue,
    assetClassDetails,
    witholdingTaxSetupDetails,
  ]);

  const submit = async (data) => {
    if (witholdingTaxSetupDetails?.length === 0) {
      toast.error(
        `Please setup witholding Tax for ${vendorDetails?.vendorType}`
      );
      return;
    }

    let totalPercentage = 0;
    let errorMessage = "";

    const payload = {
      quotationId: Number(id),
      witholdingTax: Number(data.WithholdingTax),
      vat: Number(data.VAT),
      installmentType: Number(data.InstalmentType),
      installments: [],
    };

    // Handle one-time payment
    if (data.InstalmentType === "0") {
      totalPercentage = 100; // Automatically set to 100%
      payload.installments.push({
        installementPercentage: 100,
        installementAmount: data.TotalPayable,
        paymentDate: new Date(),
      });
    } else {
      // Handle staggered payment
      for (let i = 0; i < paymentSplit; i++) {
        const percentage = Number(data[`paymentPercentage_${i}`]) || 0;
        totalPercentage += percentage;

        if (totalPercentage > 100) {
          errorMessage = "Percentage breakdown above 100";
          break;
        }

        payload.installments.push({
          installementPercentage: percentage,
          installementAmount: (data.TotalPayable * percentage) / 100,
          paymentDate: data[`paymentDate_${i}`] || new Date(),
        });
      }

      if (totalPercentage < 100 && !errorMessage) {
        errorMessage = "Percentage breakdown below 100";
      }
    }

    // If there's an error, display it and prevent form submission
    if (errorMessage) {
      toast.error(errorMessage);
      return;
    }

    try {
      setIsLoading(true);
      setRefresh(!refersh);
      const response = await dispatch(SendQuotationPaymentTerms(payload)).then(
        (res) => {
          if (res?.payload?.successful === true) {
            navigate(-1);
            toast.success(res?.payload?.statusMessage);
            setIsLoading(false);
          } else {
            toast.error(
              res?.payload?.statusMessage ||
                res?.payload?.validationErrors.map((x) => x).join(", ")
            );
            setIsLoading(false);
          }
        }
      );
    } catch (error) {
      setIsLoading(false);
      console.error("Error submitting payment terms:", error);
    }
  };

  // console.log("vendorDetails", vendorDetails);
  // console.log("requisition", requisition);

  useEffect(() => {
    dispatch(GetEmployeeBanks());
    if (vendorDetails?.vendorTypeId) {
      dispatch(
        getWitholdingTaxSetup({
          pageSize: 10000,
          pageNumber: 1,
          VendorTypeId: vendorDetails?.vendorTypeId,
        })
      );
    }
    if (consummableDetails?.[0]?.classId) {
      dispatch(
        GetConsummableClassByClassId({
          pageSize: 100000,
          currentPage: 1,
          ClassId: consummableDetails?.[0]?.classId,
        })
      );
    }
  }, [vendorDetails?.vendorTypeId]);

  // console.log("requisition", requisition);

  // useEffect(() => {
  //   if (requisition?.vendorId) {
  //     dispatch(GetSingleVendor(requisition?.vendorId));
  //   }
  // }, [requisition?.vendorId]);

  useEffect(() => {
    if (requisition?.vendorId) {
      // Pass vendorId as an object to match the structure expected by CreateQueryParams
      dispatch(GetSingleVendor({ id: requisition?.vendorId }));
    }
  }, [requisition?.vendorId]);

  useEffect(() => {
    if (requisition?.assetClass) {
      dispatch(GetAssetClass({ Name: requisition?.assetClass }));
    }

    if (requisition?.assetName) {
      dispatch(
        GetConsummableRegister({
          pageSize: 100000,
          currentPage: 1,
          sort: 0,
          filter: 2,
          searchText: requisition?.assetName,
        })
      );
    }
  }, [requisition?.assetClass, requisition?.assetName]);

  const getBankName = (id) => {
    const bank = banks?.find((x) => x.bankId === id);
    return bank?.bankName;
  };

  const handleAPIError = (response) => {
    setIsApproved(false);
    toast.error(
      response?.payload?.statusMessage ||
        response?.payload?.validationErrors.map((x) => x).join(", ")
    );
  };

  const [loadingStates, setLoadingStates] = useState({});

  const handlePaymentClick = async (paymentTerm) => {
    // console.log("res2", paymentTerms, requisition?.vendorId);

    // return;
    try {
      const res2 = await dispatch(
        SendPaymentToFinance({
          batchId: generateRandomNumberString(8),
          paymentTypeId: witholdingTaxSetupDetails[0]?.paymentTypeId,
          // totalAmount: x?.installementAmount,
          totalAmount: paymentTerm?.reduce((acc, item) => {
            return acc + item.installementAmount;
          }, 0),
          paymentDetails: paymentTerm?.map((x) => ({
            procurementInitiatorId: x?.procurementInitiatorId,
            procurementInitiatorName: x?.procurementInitiatorName,
            processId: x?.quotationId,
            recipientId: requisition?.vendorId,
            recipientType: 0, // vendor is 0
            narration: `Payment for ${assetClassDetails[0]?.description} ${requisition?.brand}`,
            amount: x?.installementAmount,
            accountNumber: vendorDetails?.accountNumber,
            bank: getBankName(vendorDetails?.bankId),
            installmentType: x?.installementPercentage > 0 ? 1 : 0,
          })),
        })
      );

      if (res2?.payload?.successful === true) {
        const payload = {
          paymentTermIds: paymentTerm?.map((x) => x?.id),
          isSentForPayment: true,
        };

        const res = await dispatch(UpdateQuotationPaymentTerms(payload));

        if (res?.payload?.successful === true) {
          toast.success(res?.payload?.statusMessage);
          navigate(-1);
          setRefresh(!refersh);
          // Set loading state for the specific x
          // setLoadingStates((prevState) => ({ ...prevState, [x.id]: false }));
        } else {
          handleAPIError(res); // Extract error handling to a function
          // setLoadingStates((prevState) => ({ ...prevState, [x.id]: false }));
        }
      } else {
        handleAPIError(res2);
        // setLoadingStates((prevState) => ({ ...prevState, [x.id]: false }));
      }
    } catch (error) {
      console.error("Error in SendPaymentToFinance:", error);
      // setLoadingStates((prevState) => ({ ...prevState, [x.id]: false }));
    }
  };

  const handlePaymentDecline = async (x) => {
    try {
      // Set loading state for the specific x
      // setLoadingStates((prevState) => ({ ...prevState, [x.id]: true }));

      const res2 = await dispatch(
        declinePaymentToFinance({
          paymentIds: x?.map((x) => x?.id),
          comment: "Decline Payment",
          status: 39,
          type: "PaymentTerms",
        })
      );

      if (res2?.payload?.successful === true) {
        const payload = {
          paymentTermIds: x?.map((x) => x?.id),
          isSentForPayment: false,
        };

        const res = await dispatch(UpdateQuotationPaymentTerms(payload));

        if (res?.payload?.successful === true) {
          toast.success(res?.payload?.statusMessage);
          navigate(-1);
          setRefresh(!refersh);
          // Set loading state for the specific x
          // setLoadingStates((prevState) => ({ ...prevState, [x.id]: false }));
        } else {
          handleAPIError(res); // Extract error handling to a function
          // setLoadingStates((prevState) => ({ ...prevState, [x.id]: false }));
        }
      } else {
        handleAPIError(res2);
        // setLoadingStates((prevState) => ({ ...prevState, [x.id]: false }));
      }
    } catch (error) {
      console.error("Error in SendPaymentToFinance:", error);
      // setLoadingStates((prevState) => ({ ...prevState, [x.id]: false }));
    }
  };

  // Calculate total installementPercentage
  const totalPercentage = paymentTerms?.reduce((acc, item) => {
    return item?.isSentForPayment !== false
      ? acc + item.installementPercentage
      : acc;
  }, 0);

  // Check if total percentage equals 100
  const isHundredPercent = totalPercentage === 100;
 

  return (
    <PageLayout title="Payment Terms">
      <>
        {/* Show only the table if totalPercentage is 100 */}
        {isHundredPercent && (
          <section className={DashboardStyle.form_section}>
            <h4 className={DashboardStyle.form_section_title}>Payment Terms</h4>
            <div
              className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
            >
              <Table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Installement Amount</th>
                    <th>Installement Percentage</th>
                    <th>Payment Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {[...paymentTerms]
                    .filter((x) => x?.isSentForPayment !== false)
                    .map((x, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{x?.installementAmount}</td>
                        <td>{x?.installementPercentage}</td>
                        <td>{FormatDateTime(x?.paymentDate)}</td>
                        <td>
                          {x?.isSentForPayment === null
                            ? "Pending"
                            : x?.isSentForPayment === false
                            ? "Declined"
                            : "Sent"}
                        </td>
                        <td>
                          {!x?.isSentForPayment && (
                            <div className="flex gap-3">
                              <button
                                style={{
                                  backgroundColor: "#305f32",
                                  padding: "8px 16px",
                                  color: "#fff",
                                  borderRadius: "10px",
                                  opacity: x?.isSentForPayment ? 0.5 : 1,
                                }}
                                disabled={x?.isSentForPayment !== null}
                                onClick={async () => handlePaymentClick([x])}
                              >
                                {loadingStates[x.id]
                                  ? "Sending..."
                                  : "Send for Payment"}
                              </button>

                              <button
                                style={{
                                  backgroundColor: "#ff0000",
                                  padding: "8px 16px",
                                  color: "#fff",
                                  borderRadius: "10px",
                                  opacity: x?.isSentForPayment ? 0.5 : 1,
                                }}
                                disabled={x?.isSentForPayment !== null}
                                onClick={async () => handlePaymentDecline([x])}
                              >
                                {loadingStates[x.id]
                                  ? "Declining..."
                                  : "Decline Payment"}
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}

                  {paymentTerms
                    .filter((x) => x?.isSentForPayment === false)
                    .map((x, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{x?.installementAmount}</td>
                        <td>{x?.installementPercentage}</td>
                        <td>{FormatDateTime(x?.paymentDate)}</td>
                        <td>Declined</td>
                        <td>
                          <div className="flex gap-3">
                            <button
                              style={{
                                backgroundColor: "gray",
                                padding: "8px 16px",
                                color: "#fff",
                                borderRadius: "10px",
                                opacity: 0.5,
                                cursor: "not-allowed",
                              }}
                              disabled={true}
                            >
                              Send for Payment
                            </button>

                            <button
                              style={{
                                backgroundColor: "gray",
                                padding: "8px 16px",
                                color: "#fff",
                                borderRadius: "10px",
                                opacity: 0.5,
                                cursor: "not-allowed",
                              }}
                              disabled={true}
                            >
                              Decline Payment
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </section>
        )}

        {/* Show only the form if totalPercentage is 0 */}
        {totalPercentage === 0 && (
          <FormProvider {...formMethods}>
            <FormTemplate handleSubmit={handleSubmit(submit)}>
              <section className={DashboardStyle.form_section}>
                <h4 className={DashboardStyle.form_section_title}></h4>
                <div className={DashboardStyle.inputs_group}>
                  <div>
                    <FormattedNumberInput
                      title="Total Price"
                      camelCase="TotalPrice"
                      placeholder="Enter Unit Price"
                      disabled={true}
                      value={requisition?.totalPrice}
                      isOptional={true}
                    />
                    <FormInput
                      title={`Service Fee`}
                      camelCase="managementFee"
                      isOptional={true}
                    />
                  </div>

                  <div>
                    <FormattedNumberInput
                      title="Gross"
                      camelCase="Gross"
                      isOptional={true}
                      placeholder=""
                      disabled={true}
                      value={watch("gross")}
                    />

                    <FormattedNumberInput
                      title="VAT"
                      camelCase="VAT"
                      isOptional={true}
                      placeholder="Enter VAT"
                      disabled={true}
                    />
                  </div>

                  <div>
                    <FormattedNumberInput
                      title="Gross + VAT"
                      camelCase="grossPlusVat"
                      placeholder=""
                      disabled={true}
                      isOptional={true}
                    />
                    <FormattedNumberInput
                      title="Withholding Tax"
                      camelCase="WithholdingTax"
                      placeholder=""
                      disabled={true}
                      isOptional={true}
                    />
                  </div>

                  <div>
                    <FormattedNumberInput
                      title="Total Payable"
                      camelCase="TotalPayable"
                      placeholder=""
                      disabled={true}
                      isOptional={true}
                    />
                    <FormSelect
                      title="Instalment Type"
                      camelCase="InstalmentType"
                      placeholder=""
                      array={
                        <>
                          <option value={0}>One Time Payment</option>
                          <option value={1}>Staggered</option>
                        </>
                      }
                    />
                  </div>

                  {installmentType === "1" && (
                    <>
                      <div>
                        <FormInput
                          title="Payment Split"
                          camelCase="paymentSplit"
                          placeholder="Enter number of payments"
                        />
                      </div>

                      {[...Array(Number(paymentSplit)).keys()].map((index) => {
                        const installmentPercentage = watch(
                          `paymentPercentage_${index}`
                        );
                        const installmentAmount =
                          (Number(installmentPercentage) / 100) *
                          watch("TotalPayable");

                        // Convert index to ordinal by passing (index + 1) to getOrdinal
                        const ordinalIndex = getOrdinal(index + 1);

                        return (
                          <div
                            key={index}
                            className="border border-gray-200 p-4 rounded-lg my-4"
                          >
                            <FormInput
                              title={`${ordinalIndex} Payment %`}
                              camelCase={`paymentPercentage_${index}`}
                              placeholder="Enter percentage"
                            />
                            <FormattedNumberInput
                              title={`${ordinalIndex} Payment Amount`}
                              camelCase={`paymentAmount_${index}`}
                              placeholder=""
                              value={installmentAmount || 0}
                              disabled={true}
                              isOptional={true}
                            />
                            <FormInput
                              title={`${ordinalIndex} Payment Date`}
                              camelCase={`paymentDate_${index}`}
                              placeholder="Select date"
                              type="date"
                            />
                          </div>
                        );
                      })}
                    </>
                  )}
                </div>
              </section>

              <div className={DashboardStyle.button_cage}>
                <SupportButtons
                  width="auto"
                  className={DashboardStyle?.button_cage_weight}
                >
                  Cancel
                </SupportButtons>
                <ActionButtons
                  disabled={requisition?.totalPrice === 0 || isLoading}
                  width="auto"
                  className={DashboardStyle?.button_cage_weight}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </ActionButtons>
              </div>
            </FormTemplate>
          </FormProvider>
        )}

        {/* Show both the form and table if totalPercentage is not 100 and not 0 */}
        {totalPercentage !== 0 && !isHundredPercent && (
          <>
            <FormProvider {...formMethods}>
              <FormTemplate handleSubmit={handleSubmit(submit)}>
                <section className={DashboardStyle.form_section}>
                  <h4 className={DashboardStyle.form_section_title}></h4>
                  <div className={DashboardStyle.inputs_group}>
                    <div>
                      <FormInput
                        title="Total Price"
                        camelCase="TotalPrice"
                        placeholder="Enter Unit Price"
                        disabled={true}
                        value={requisition?.totalPrice}
                        isOptional={true}
                      />
                      <FormInput
                        title={`Service Fee`}
                        camelCase="managementFee"
                        isOptional={true}
                      />
                    </div>

                    <div>
                      <FormInput
                        title="Gross"
                        camelCase="Gross"
                        isOptional={true}
                        placeholder=""
                        disabled={true}
                        value={watch("gross")}
                      />

                      <FormInput
                        title="VAT"
                        camelCase="VAT"
                        isOptional={true}
                        placeholder="Enter VAT"
                        disabled={true}
                      />
                    </div>

                    <div>
                      <FormInput
                        title="Gross + VAT"
                        camelCase="grossPlusVat"
                        placeholder=""
                        disabled={true}
                        isOptional={true}
                      />
                      <FormInput
                        title="Withholding Tax"
                        camelCase="WithholdingTax"
                        placeholder=""
                        disabled={true}
                        isOptional={true}
                      />
                    </div>

                    <div>
                      <FormInput
                        title="Total Payable"
                        camelCase="TotalPayable"
                        placeholder=""
                        disabled={true}
                        isOptional={true}
                      />
                      <FormSelect
                        title="Instalment Type"
                        camelCase="InstalmentType"
                        placeholder=""
                        array={
                          <>
                            <option value={0}>One Time Payment</option>
                            <option value={1}>Staggered</option>
                          </>
                        }
                      />
                    </div>

                    {installmentType === "1" && (
                      <>
                        <div>
                          <FormInput
                            title="Payment Split"
                            camelCase="paymentSplit"
                            placeholder="Enter number of payments"
                          />
                        </div>

                        {[...Array(Number(paymentSplit)).keys()].map(
                          (index) => {
                            const installmentPercentage = watch(
                              `paymentPercentage_${index}`
                            );
                            const installmentAmount =
                              (Number(installmentPercentage) / 100) *
                              watch("TotalPayable");

                            // Convert index to ordinal by passing (index + 1) to getOrdinal
                            const ordinalIndex = getOrdinal(index + 1);

                            return (
                              <div
                                key={index}
                                className="border border-gray-200 p-4 rounded-lg my-4"
                              >
                                <FormInput
                                  title={`${ordinalIndex} Payment %`}
                                  camelCase={`paymentPercentage_${index}`}
                                  placeholder="Enter percentage"
                                />
                                <FormInput
                                  title={`${ordinalIndex} Payment Amount`}
                                  camelCase={`paymentAmount_${index}`}
                                  placeholder=""
                                  value={installmentAmount || 0}
                                  disabled={true}
                                  isOptional={true}
                                />
                                <FormInput
                                  title={`${ordinalIndex} Payment Date`}
                                  camelCase={`paymentDate_${index}`}
                                  placeholder="Select date"
                                  type="date"
                                />
                              </div>
                            );
                          }
                        )}
                      </>
                    )}
                  </div>
                </section>

                <div className={DashboardStyle.button_cage}>
                  <SupportButtons
                    width="auto"
                    className={DashboardStyle?.button_cage_weight}
                  >
                    Cancel
                  </SupportButtons>
                  <ActionButtons
                    disabled={requisition?.totalPrice === 0 || isLoading}
                    width="auto"
                    className={DashboardStyle?.button_cage_weight}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </ActionButtons>
                </div>
              </FormTemplate>
            </FormProvider>

            <section className={DashboardStyle.form_section}>
              <h4 className={DashboardStyle.form_section_title}>
                Payment Terms
              </h4>
              <div
                className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
              >
                <Table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Installement Amount</th>
                      <th>Installement Percentage</th>
                      <th>Payment Date</th>
                      <th>Status</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {paymentTerms
                      // ?.filter((x) => x?.isSentForPayment !== false)
                      ?.map((x, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{x?.installementAmount}</td>
                          <td>{x?.installementPercentage}</td>
                          <td>{FormatDateTime(x?.paymentDate)}</td>
                          <td>
                            {x?.isSentForPayment === null
                              ? "Pending"
                              : x?.isSentForPayment === false
                              ? "Declined"
                              : "Sent"}
                          </td>
                          {/* <td>
                            {!x?.isSentForPayment && (
                              <div className="flex gap-3">
                                <button
                                  style={{
                                    backgroundColor: "#305f32",
                                    padding: "8px 16px",
                                    color: "#fff",
                                    borderRadius: "10px",
                                    opacity: x?.isSentForPayment ? 0.5 : 1,
                                  }}
                                  disabled={x?.isSentForPayment !== null}
                                  onClick={async () => handlePaymentClick(x)}
                                >
                                  {loadingStates[x.id]
                                    ? "Sending..."
                                    : "Send for Payment"}
                                </button>

                                <button
                                  style={{
                                    backgroundColor: "#ff0000",
                                    padding: "8px 16px",
                                    color: "#fff",
                                    borderRadius: "10px",
                                    opacity: x?.isSentForPayment ? 0.5 : 1,
                                  }}
                                  disabled={x?.isSentForPayment !== null}
                                  onClick={async () => handlePaymentDecline(x)}
                                >
                                  {loadingStates[x.id]
                                    ? "Declining..."
                                    : "Decline Payment"}
                                </button>
                              </div>
                            )}
                          </td> */}
                        </tr>
                      ))}

                    {/* {paymentTerms
                      ?.filter((x) => x?.isSentForPayment === false)
                      ?.map((x, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{x?.installementAmount}</td>
                          <td>{x?.installementPercentage}</td>
                          <td>{FormatDateTime(x?.paymentDate)}</td>
                          <td>Declined</td>
                          <td>
                            <div className="flex gap-3">
                              <button
                                style={{
                                  backgroundColor: "gray",
                                  padding: "8px 16px",
                                  color: "#fff",
                                  borderRadius: "10px",
                                  opacity: 0.5,
                                  cursor: "not-allowed",
                                }}
                                disabled={true}
                              >
                                Send for Payment
                              </button>

                              <button
                                style={{
                                  backgroundColor: "gray",
                                  padding: "8px 16px",
                                  color: "#fff",
                                  borderRadius: "10px",
                                  opacity: 0.5,
                                  cursor: "not-allowed",
                                }}
                                disabled={true}
                              >
                                Decline Payment
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))} */}
                  </tbody>
                </Table>
                <div className="flex flex-row gap-3 justify-end">
                  <button
                    style={{
                      backgroundColor: "#305f32",
                      padding: "8px 16px",
                      color: "#fff",
                      borderRadius: "10px",
                      // opacity: x?.isSentForPayment ? 0.5 : 1,
                    }}
                    // disabled={x?.isSentForPayment !== null}
                    onClick={() => handlePaymentClick()}
                  >
                    {/* {loadingStates[x.id] ? "Sending..." : "Send for Payment"} */}
                    Send for Payment
                  </button>

                  <button
                    style={{
                      backgroundColor: "#ff0000",
                      padding: "8px 16px",
                      color: "#fff",
                      borderRadius: "10px",
                      // opacity: x?.isSentForPayment ? 0.5 : 1,
                    }}
                    // disabled={x?.isSentForPayment !== null}
                    onClick={() => handlePaymentDecline()}
                  >
                    {/* {loadingStates[x.id] ? "Declining..." : "Decline Payment"} */}
                    Decline Payment
                  </button>
                </div>
              </div>
            </section>
          </>
        )}
      </>
    </PageLayout>
  );
}

export default AddPaymentTerms;
